import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "receiptvault_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function receiptImageUrl(receiptId) {
  const t = getToken();
  const q = t ? `?auth=${encodeURIComponent(t)}` : "";
  return `${API}/receipts/${receiptId}/image${q}`;
}

export function quarterlyPdfUrl(year, quarter) {
  const t = getToken();
  const q = t ? `&auth=${encodeURIComponent(t)}` : "";
  return `${API}/reports/quarterly/pdf?year=${year}&quarter=${quarter}${q}`;
}
